import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export const NOTIFICATIONS_URL = new InjectionToken<string>('NOTIFICATIONS_URL', {
  providedIn: 'root',
  factory: () => environment.notificationsUrl,
});

export const CLIENT_ID = new InjectionToken<string>('CLIENT_ID', {
  providedIn: 'root',
  factory: () => environment.clientId,
});

export const BASE_URL = new InjectionToken<string>('BASE_URL', {
  providedIn: 'root',
  factory: () => environment.apiBase,
});

export const AUTH_BASE_URL = new InjectionToken<string>('AUTH_BASE_URL', {
  providedIn: 'root',
  factory: () => environment.authority,
});

export const APP_VERSION = new InjectionToken<string>('APP_VERSION', {
  providedIn: 'root',
  factory: () => environment.appVersion,
});

export const DOWNLOAD_ATTACHMENT_URL = new InjectionToken<string>('DOWNLOAD_ATTACHMENT_URL', {
  providedIn: 'root',
  factory: () => environment.downloadAttachmentUrl,
});

export const APP_DOCUMENTATION_BASE_URL = new InjectionToken<string>('APP_DOCUMENTATION_BASE_URL', {
  providedIn: 'root',
  factory: () => environment.documentationBaseUrl,
});
